import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import {onMounted, ref, reactive} from "vue";
import apiInsuranceCancelation from "@/modules/InsuranceCancelation/api";
import InsuranceCancelation from "@/shared/model/InsuranceCancelation";
import {useNavigationStore} from "@/modules/Navigation/store";
import InsuranceCancelationDetailsComponent
  from "@/modules/InsuranceCancelation/components/InsuranceCancelationDetailsComponent.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import HistoryListComponent from "@/modules/History/components/HistoryListComponent.vue";
import apiHistory from "@/modules/History/api";
import History from "@/shared/model/History";
import getGuid from "@/shared/utils/getGuid";

interface Props {
  id?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceCancelationDetailsPage',
  props: {
    id: { default: undefined }
  },
  setup(__props: any) {


const props = __props


const _insuranceCancelationId = ref<string | undefined>(undefined)
const _loadDetails = ref(false)
const _key = ref("")
const _insuranceCancelation = ref<InsuranceCancelation | undefined>(undefined)
const _navigationStore = useNavigationStore()
const _loadHistory = ref(false)
const _history: History[] = reactive<History[]>([])


async function load() {

  if (!props.id) {
    return;
  }
  _insuranceCancelationId.value = props.id

  _key.value = getGuid();
  const t_loadDetails = loadDetails(_key.value);
  const t_loadHistory = loadHistory(_key.value);

  await Promise.allSettled([t_loadDetails, t_loadHistory])
}

async function loadDetails(key: string) {
  if (!_insuranceCancelationId.value)
    return
  _loadDetails.value = true
  const res = await apiInsuranceCancelation.load(_insuranceCancelationId.value)
  if (_key.value !== key) {
    return
  }
  if (res) {
    _insuranceCancelation.value = res.insuranceCancelation
  }
  _loadDetails.value = false
}

async function loadHistory(key: string) {
  if (!_insuranceCancelationId.value)
    return
  _loadHistory.value = true
  _history.length = 0
  const lst = await apiHistory.listInsuranceCancelation(_insuranceCancelationId.value)
  if (_key.value !== key) {
    return
  }
  if (lst) {
    _history.push(...lst)
  }
  _loadHistory.value = false
}

async function refresh() {
  await load();
}

onMounted(() => {
  if (!props.id) {
    _navigationStore.back()
    return;
  }
  load()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: "Stornierung (beta)"
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_insuranceCancelation.value?.insuranceNumber), 1)
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Refresh,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (refresh()))
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(InsuranceCancelationDetailsComponent, { data: _insuranceCancelation.value }, null, 8, ["data"])
            ]),
            _: 1
          }, 512), [
            [_vShow, !_loadDetails.value]
          ]),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                [_vShow, _loadDetails.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Historie", -1)
            ]))]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(HistoryListComponent, { data: _history }, null, 8, ["data"])
            ]),
            _: 1
          }, 512), [
            [_vShow, !_loadHistory.value]
          ]),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                [_vShow, _loadHistory.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_vShow, _loadHistory.value||_history.length>0]
      ])
    ]),
    _: 1
  }))
}
}

})